// Constantes de la aplicación

// Roles de usuario
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user'
} as const

// Estados de usuario
export const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
} as const

// Tipos de animales comunes
export const ANIMAL_TYPES = {
  DOG: 'Perro',
  CAT: 'Gato',
  BIRD: 'Ave',
  RABBIT: 'Conejo',
  HAMSTER: 'Hámster',
  FISH: 'Pez'
} as const

// Estados de Mascotijos
export const PET_STATUS = {
  HEALTHY: 'healthy',
  SICK: 'sick',
  TREATMENT: 'treatment',
  RECOVERED: 'recovered'
} as const

// Tipos de actividad
export const ACTIVITY_TYPES = {
  USER_REGISTERED: 'user_registered',
  USER_UPDATED: 'user_updated',
  PET_REGISTERED: 'pet_registered',
  PET_UPDATED: 'pet_updated',
  BREED_CREATED: 'breed_created',
  ANIMAL_TYPE_CREATED: 'animal_type_created',
  LOGIN: 'login',
  LOGOUT: 'logout'
} as const

// Códigos de respuesta HTTP
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500
} as const

// Mensajes de error comunes
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Error de conexión. Verifica tu conexión a internet.',
  UNAUTHORIZED: 'No tienes permisos para realizar esta acción.',
  NOT_FOUND: 'El recurso solicitado no fue encontrado.',
  FORBIDDEN: 'No tienes permisos para realizar esta acción.',
  VALIDATION_ERROR: 'Los datos proporcionados no son válidos.',
  SERVER_ERROR: 'Error interno del servidor. Intenta nuevamente más tarde.',
  SESSION_EXPIRED: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.'
} as const

// Mensajes de éxito
export const SUCCESS_MESSAGES = {
  USER_CREATED: 'Usuario creado exitosamente.',
  USER_UPDATED: 'Usuario actualizado exitosamente.',
  USER_DELETED: 'Usuario eliminado exitosamente.',
  PET_CREATED: 'Mascotijo registrada exitosamente.',
  PET_UPDATED: 'Mascotijo actualizada exitosamente.',
  PET_DELETED: 'Mascotijo eliminada exitosamente.',
  BREED_CREATED: 'Raza creada exitosamente.',
  BREED_UPDATED: 'Raza actualizada exitosamente.',
  BREED_DELETED: 'Raza eliminada exitosamente.',
  ANIMAL_TYPE_CREATED: 'Tipo de animal creado exitosamente.',
  ANIMAL_TYPE_UPDATED: 'Tipo de animal actualizado exitosamente.',
  ANIMAL_TYPE_DELETED: 'Tipo de animal eliminado exitosamente.',
  PASSWORD_CHANGED: 'Contraseña cambiada exitosamente.',
  PROFILE_UPDATED: 'Perfil actualizado exitosamente.'
} as const

// Rutas de la aplicación
export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  USERS: '/users',
  PETS: '/pets',
  ANIMAL_TYPES: '/animal-types',
  BREEDS: '/breeds'
} as const

// Configuración de tablas
export const TABLE_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 20, 50],
  MAX_PAGE_SIZE: 100
} as const

// Configuración de archivos
export const FILE_CONFIG = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.webp']
} as const

// Patrones de validación
export const VALIDATION_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[\+]?[1-9][\d]{0,15}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/,
  NAME: /^[a-zA-ZÀ-ÿ\s]{2,50}$/
} as const

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES]
export type UserStatus = typeof USER_STATUS[keyof typeof USER_STATUS]
export type PetStatus = typeof PET_STATUS[keyof typeof PET_STATUS]
export type ActivityType = typeof ACTIVITY_TYPES[keyof typeof ACTIVITY_TYPES]